import { render, staticRenderFns } from "./expand-column.vue?vue&type=template&id=510ec06d"
import script from "./expand-column.vue?vue&type=script&lang=js"
export * from "./expand-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('510ec06d')) {
      api.createRecord('510ec06d', component.options)
    } else {
      api.reload('510ec06d', component.options)
    }
    module.hot.accept("./expand-column.vue?vue&type=template&id=510ec06d", function () {
      api.rerender('510ec06d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/reports/messages-lag/expand-column.vue"
export default component.exports